const PIXEL_ID = '1553300692930973'
const DELAY_AFTER_LOAD_MS = 2500

type FbqFunction = (...args: unknown[]) => void

declare global {
  interface Window {
    fbq?: FbqFunction & {
      callMethod?: FbqFunction
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

function loadPixelScript(): void {
  if (window.fbq) return

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  } as NonNullable<Window['fbq']>

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

let initialized = false

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  loadPixelScript()
  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/**
 * Carga el pixel después del evento load (+2.5s) o en la primera interacción
 * del usuario, lo que ocurra primero. Los eventos se encolan en fbq, así que
 * PageView y AddToCart se disparan exactamente igual que antes.
 */
export function scheduleMetaPixel(): () => void {
  if (typeof window === 'undefined') return () => undefined

  let timeoutId: number | undefined

  const start = () => {
    cleanup()
    initMetaPixel()
  }

  const startAfterDelay = () => {
    timeoutId = window.setTimeout(start, DELAY_AFTER_LOAD_MS)
  }

  const interactionEvents = ['pointerdown', 'keydown', 'touchstart', 'scroll']

  const cleanup = () => {
    if (timeoutId) window.clearTimeout(timeoutId)
    window.removeEventListener('load', startAfterDelay)
    interactionEvents.forEach((event) =>
      window.removeEventListener(event, start)
    )
  }

  if (document.readyState === 'complete') {
    startAfterDelay()
  } else {
    window.addEventListener('load', startAfterDelay, { once: true })
  }

  interactionEvents.forEach((event) =>
    window.addEventListener(event, start, { once: true, passive: true })
  )

  return cleanup
}

export function trackAddToCart(): void {
  if (typeof window === 'undefined') return

  // Garantiza que el pixel exista aunque el usuario compre antes del delay.
  initMetaPixel()

  window.fbq?.('track', 'AddToCart', {
    content_name: 'The Visual Disruption Bible 2.0',
    content_ids: ['53127621607705'],
    content_type: 'product',
    value: 11.99,
    currency: 'USD'
  })
}
